
const digest = '41aee729909eb3798d0dc2375f2fda70e11b00663de79288d8cfb1794b4e9802';
const classes = {"wrapper":"_wrapper_1rr8b_1","scrollContainer":"_scrollContainer_1rr8b_6","topScroller":"_topScroller_1rr8b_11","scrollWrapper":"_scrollWrapper_1rr8b_40","table":"_table_1rr8b_68","thead":"_thead_1rr8b_73","tr":"_tr_1rr8b_73","th":"_th_1rr8b_73","fixed":"_fixed_1rr8b_81","tbody":"_tbody_1rr8b_88","td":"_td_1rr8b_88"};
const css = `._wrapper_1rr8b_1 {
  width: 100%;
  overflow: hidden;
  position: relative;
}
._wrapper_1rr8b_1 ._scrollContainer_1rr8b_6 {
  width: 100%;
  position: relative;
  overflow-x: hidden;
}
._wrapper_1rr8b_1 ._scrollContainer_1rr8b_6 ._topScroller_1rr8b_11 {
  overflow-x: scroll;
  overflow-y: hidden;
  -ms-overflow-style: auto;
  cursor: pointer;
  width: 100%;
  top: 0;
  height: 6px;
}
._wrapper_1rr8b_1 ._scrollContainer_1rr8b_6 ._topScroller_1rr8b_11::-webkit-scrollbar {
  display: block;
  width: 4px;
  height: 6px;
  padding: 10px 2px;
  cursor: pointer;
}
._wrapper_1rr8b_1 ._scrollContainer_1rr8b_6 ._topScroller_1rr8b_11::-webkit-scrollbar-track {
  background: #f1f1f1;
}
._wrapper_1rr8b_1 ._scrollContainer_1rr8b_6 ._topScroller_1rr8b_11::-webkit-scrollbar-thumb {
  background: #3e3f42;
  border-radius: 4px;
  cursor: pointer;
}
._wrapper_1rr8b_1 ._scrollContainer_1rr8b_6 ._topScroller_1rr8b_11::-webkit-scrollbar-thumb:hover {
  background: #3e3f42;
  border-radius: 4px;
  cursor: pointer;
}
._wrapper_1rr8b_1 ._scrollContainer_1rr8b_6 ._scrollWrapper_1rr8b_40 {
  overflow-x: scroll;
  -ms-overflow-style: auto;
  cursor: pointer;
  width: 100%;
  height: calc(100% - 6px);
  overflow-y: hidden;
}
._wrapper_1rr8b_1 ._scrollContainer_1rr8b_6 ._scrollWrapper_1rr8b_40::-webkit-scrollbar {
  display: block;
  width: 4px;
  height: 6px;
  padding: 10px 2px;
  cursor: pointer;
}
._wrapper_1rr8b_1 ._scrollContainer_1rr8b_6 ._scrollWrapper_1rr8b_40::-webkit-scrollbar-track {
  background: #f1f1f1;
}
._wrapper_1rr8b_1 ._scrollContainer_1rr8b_6 ._scrollWrapper_1rr8b_40::-webkit-scrollbar-thumb {
  background: #3e3f42;
  border-radius: 4px;
  cursor: pointer;
}
._wrapper_1rr8b_1 ._scrollContainer_1rr8b_6 ._scrollWrapper_1rr8b_40::-webkit-scrollbar-thumb:hover {
  background: #3e3f42;
  border-radius: 4px;
  cursor: pointer;
}
._wrapper_1rr8b_1 ._table_1rr8b_68 {
  font-family: Rubik, "sans-serif";
  border-color: #eaedf3;
  width: 100%;
}
._wrapper_1rr8b_1 ._table_1rr8b_68 ._thead_1rr8b_73 ._tr_1rr8b_73 ._th_1rr8b_73 {
  font-size: 14px;
  font-weight: 400;
  color: #9ea0a5;
  padding: 10px 0;
  text-align: center;
  background: #ffffff;
}
._wrapper_1rr8b_1 ._table_1rr8b_68 ._thead_1rr8b_73 ._tr_1rr8b_73 ._fixed_1rr8b_81 {
  position: absolute;
  border: 0;
  border-right: 1px solid #eceef4;
  border-left: 1px solid #eceef4;
  left: 0;
}
._wrapper_1rr8b_1 ._table_1rr8b_68 ._tbody_1rr8b_88 ._tr_1rr8b_73 ._td_1rr8b_88 {
  background: rgb(250, 250, 252);
}
._wrapper_1rr8b_1 ._table_1rr8b_68 ._tbody_1rr8b_88 ._tr_1rr8b_73 ._fixed_1rr8b_81 {
  position: absolute;
  background: #ffffff;
  border: 0;
  border-right: 1px solid #eceef4;
  border-left: 1px solid #eceef4;
  left: 0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  